import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Õ",
  "use": "icon-Õ-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Õ\">\n<path d=\"M16.4747 45.784V13.816L42.6827 29.8L16.4747 45.784ZM46.9547 28.312L15.6587 9.256C15.1307 8.92 14.4587 8.92 13.8827 9.208C13.3547 9.544 13.0187 10.12 13.0187 10.744V48.904C13.0187 49.576 13.3547 50.152 13.8827 50.44C14.1707 50.584 14.4587 50.68 14.7467 50.68C15.0827 50.68 15.3707 50.584 15.6587 50.44L46.9547 31.288C47.4347 31 47.7707 30.424 47.7707 29.8C47.7707 29.224 47.4347 28.648 46.9547 28.312Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol